import { AxiosInstance } from 'axios'

import { InjectionKey } from '@vue/composition-api'

import * as TranscriptionManager from './transcription-manager-types'
import { TranscriptPayloadV2 } from '../contexts/transcription/src/transcription.api'

export class TranscriptionManagerApi {
  constructor(private client: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }
  async LoadTranscript(
    transcript: number,
    version: number,
    include_json = false
  ) {
    return this.client
      .get<TranscriptionManager.TranscriptResponse>(
        this.path(`/transcript/load/${transcript}/${version}`),
        {
          params: { include_json }
        }
      )
      .then(response => response.data)
  }
  async StartTagging(id: number, transcript: TranscriptPayloadV2) {
    return this.client
      .post<TranscriptionManager.AutoTaggingResponse>(
        this.path(`/transcript/start-tagging`),
        {
          data: {
            id,
            transcript
          }
        }
      )
      .then(response => response.data)
  }
}

export const TranscriptionManagerApiKey: InjectionKey<TranscriptionManagerApi> = Symbol()
